import { PureComponent } from 'react';
import { connect } from 'react-redux';

import forOwn from 'lodash/forOwn';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { change, getFormValues, isDirty } from 'redux-form';

import { withTransl } from 'shared/lib/i18n';

import VMSListComponent from '../components/VMSListComponent';

import { onModalClose, showConfirmModal } from '../../Modal/actions';
import { getVisitorKeysData, putVisitorKeysData } from '../actions';

import * as commonSelectors from '../../Shared/selectors';

const FORM_NAME = 'vmsSettings';

class VMSListContainer extends PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.id === '' && get(nextProps, 'buildings[0].id', false)) {
      nextProps.getVisitorKeysData(nextProps.buildings[0].id);
      return {
        id: nextProps.buildings[0].id,
        name: nextProps.buildings[0].name,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      id: '',
    };
  }

  getBuildingData = (event) => {
    const { form, dirty, setNewValue, getVisitorKeysData } = this.props;

    const id = event.currentTarget.getAttribute('id');

    let isShowModal = false;

    if (form && dirty) {
      isShowModal = true;
    } else {
      getVisitorKeysData(id);
    }
    this.setState(
      {
        name: get(event, 'target.innerText', ''),
        id,
        formValues: form,
      },
      () => {
        if (isShowModal) {
          forOwn(form, (value, key) => setNewValue(key, value));
          this.showModal();
        }
      },
    );
  };

  saveChanges = () => {
    const { putVisitorKeysData, visitorKeys } = this.props;
    const { formValues } = this.state;
    const {
      residentCanSendKey,
      residentMaxSentKeys,
      staffMaxSentKeys,
      pm_should_approve_resident_key,
      visitorPhotoRequired,
      notifyPM,
    } = formValues;
    const data = {
      residentCanSendKey,
      residentMaxSentKeys,
      staffMaxSentKeys,
      pm_should_approve_resident_key,
      visitorPhotoRequired,
      notifyPM,
      buildings: [visitorKeys.building],
    };
    putVisitorKeysData(data, false);
    this.onSaveChangesModalClose();
  };

  onSaveChangesModalClose = () => {
    const { closeModal, getVisitorKeysData } = this.props;
    const { id } = this.state;
    closeModal();
    getVisitorKeysData(id);
  };

  showModal = () => {
    const { showModal, closeModal, t } = this.props;
    const customActions = [
      {
        label: t('actions.cancel'),
        onClick: closeModal,
        color: 'inherit',
      },
      {
        label: t('actions.doNotSave'),
        onClick: this.onSaveChangesModalClose,
        color: 'secondary',
      },
      {
        label: t('actions.save'),
        onClick: this.saveChanges,
        color: 'primary',
      },
    ];
    const modalProps = {
      title: t('modal.title.saveChanges'),
      bodyText: t('modal.body.saveChanges'),
      customActions,
    };
    return showModal(modalProps);
  };

  render() {
    const { name, id } = this.state;
    const { visitorKeys, buildings } = this.props;
    const props = {
      getBuildingData: this.getBuildingData,
      name,
      id,
      prevId: visitorKeys?.building,
      hasBuildingsList: buildings?.length > 1,
      ...this.props,
    };
    return <VMSListComponent {...props} />;
  }
}

const mapStateToProps = (state) => {
  const { visitorKeys } = state;
  const isMobileScreen = commonSelectors.getIsMobileScreen(state);
  return {
    visitorKeys,
    isMobileScreen,
    dirty: isDirty(FORM_NAME)(state),
    form: getFormValues(FORM_NAME)(state) ?? {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  getVisitorKeysData: (id) => getVisitorKeysData(dispatch, id),
  putVisitorKeysData: (data, saveChangesUserMade) =>
    putVisitorKeysData(dispatch, data, saveChangesUserMade),
  setNewValue: (field, value) => dispatch(change(FORM_NAME, field, value)),
  showModal: (modalProps) => showConfirmModal(dispatch, modalProps),
  closeModal: () => onModalClose(dispatch),
});

VMSListContainer.propTypes = {
  form: PropTypes.instanceOf(Object),
  dirty: PropTypes.bool,
  setNewValue: PropTypes.func,
  getVisitorKeysData: PropTypes.func,
  buildings: PropTypes.instanceOf(Array),
  putVisitorKeysData: PropTypes.func,
  visitorKeys: PropTypes.instanceOf(Object),
  closeModal: PropTypes.func,
  showModal: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTransl()(VMSListContainer));
